<template>
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.125 9C10.125 11.385 8.1975 13.3125 5.8125 13.3125C3.4275 13.3125 1.5 11.385 1.5 9C1.5 6.615 3.4275 4.6875 5.8125 4.6875" stroke="#6782F6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M7.5 9C7.5 6.5175 9.5175 4.5 12 4.5C14.4825 4.5 16.5 6.5175 16.5 9C16.5 11.4825 14.4825 13.5 12 13.5" stroke="#6782F6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>